// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import textColorStyles from '../../../styles/atoms/text-color.module.css'
import {
  IconProps,
  computeStrokeWidth,
  computeSize,
  IconComponentRef,
} from '../helpers'
const GoalThreeQuartersIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'goal-three-quarters'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(
          className,
          styles.base,
          color && textColorStyles[color],
        )}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 6.47713 6.47713 2 12 2C17.5229 2 22 6.47713 22 12C22 17.5229 17.5229 22 12 22C6.47713 22 2 17.5229 2 12ZM12 5.33333C8.31795 5.33333 5.33333 8.31795 5.33333 12H12V5.33333Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
GoalThreeQuartersIcon.displayName = 'GoalThreeQuartersIcon'
export { GoalThreeQuartersIcon }
